import * as React from 'react';

export const useScrollToTop = (id: string, origin: string) => {
  React.useEffect(() => {
    const elm = document.getElementById(id);
    if (elm) {
      console.log("Scrolling to top of element with id '" + id + "'");

      elm.scrollTop = 0;
    }
  }, [origin, id]);
};
